<template>
  <div>
    <div v-show="imageFiles.length || localPicturePath" class="w4 flex items-center justify-center">
      <div class="flex flex-column items-center" v-show="localPicturePath || (imageFiles.length && imageFiles[0].success)">
        <div class="image-container relative db cover center h4 w4 pa3" :style=" { 'background-image': 'url(' + picture + ')' }">
        </div>
        <button class="btn w4 f6" @click="deleteImage">{{$t("app.delete")}}</button>
      </div>
      <div v-show="imageFiles.length && imageFiles[0].progress < 100" class="ba br2 b--light-silver flex justify-center items-center h4 w4">
        <clip-loader :loading="(imageFiles[0] && imageFiles[0].progress < 100)" :color="color" :size="size"></clip-loader>
      </div>
    </div>
    <div class="flex flex-column h-100 justify-end" v-show="!imageFiles.length && !localPicturePath">
      <label for="file" class="flex justify-center item-center pa3 pointer w4">
        <font-awesome-icon class="iconColor pa2 white" icon="upload" size="5x"/>
      </label>
      <div class="flex flex-column justify-center">
        <file-upload
          class="btn ph2 pointer"
          :post-action="url"
          :headers="postFileHeaders"
          extensions="jpg,jpeg,png,webp"
          v-model="imageFiles"
          ref="imageUpload"
          @input-file="imageInputFile"
          @input-filter="imageInputFilter">
          {{$t("uploadPicture.selectPicture")}}
        </file-upload>
        <span v-if="trackEdit === true" class="sizeImg">Size 200x200</span>
        <span v-if="newPlaylist === true" class="sizeImg">Size 200x200</span>
      </div>
    </div>
  </div>
</template>

<script>
import FileUpload from 'vue-upload-component'
import consts from '@/consts'
import auth from '@/auth'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

export default {
  name: 'upload-image',
  props: {
    path: {
      required: true
    },
    picturePath: {
      default: ''
    },
    trackEdit: {
      default: 'false'
    },
    newPlaylist: {
      default: 'false'
    }
  },
  data () {
    return {
      imageFiles: [],
      color: '#808080',
      size: '30px',
      localPicturePath: ''
    }
  },
  components: {
    FontAwesomeIcon,
    FileUpload,
    ClipLoader
  },
  created () {
    this.localPicturePath = this.picturePath
  },
  computed: {
    url () {
      return consts.API_BASE_URL + this.path
    },
    postFileHeaders: function () {
      return auth.getHeader()
    },
    picture () {
      if (this.imageFiles.length > 0) {
        if (this.imageFiles[0].success && this.imageFiles[0].response.status === 'ok') {
          return consts.MEDIA_BASE_URL + this.imageFiles[0].response.data.path + this.imageFiles[0].response.data.filename
        } else if (this.imageFiles[0].response.status === 'error') {
          this.$toasted.show(this.$t('tracks.newTrack.imageError'), {type: 'error'})
          this.imageFiles = []
        }
      } else if (this.localPicturePath) {
        return this.localPicturePath
      }
    }
  },
  methods: {
    deleteImage () {
      this.localPicturePath = ''
      this.imageFiles = []
      this.$emit('uploadFinished', '')
    },
    imageInputFile: function (newFile, oldFile) {
      // auto start
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!this.$refs.imageUpload.active) {
          this.$emit('uploadStart')
          this.$refs.imageUpload.active = true
        }
      }
      if (newFile && oldFile) {
        if (newFile.success !== oldFile.success) {
          if (newFile.response) {
            this.$emit('uploadFinished', newFile.response.data.filename)
          }
        }
      }
    },
    imageInputFilter: function (newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Filter non-image file
        if (!/\.(jpg|jpeg|png|webp)$/i.test(newFile.name)) {
          this.$toasted.show(this.$t('tracks.newTrack.imageType'), {type: 'error'})
          return prevent()
        }
      }
    }
  }

}
</script>

<style>
  .sizeImg {
    padding: 5px 31px;
  }
</style>



// WEBPACK FOOTER //
// src/components/UploadImage.vue